module.exports = __webpack_public_path__ + "static/media/GeneralRegulations.2217fac8.pdf";